import React from "react";

interface IProps {
  heading: string;
  body: string;
  ctaLabel: string;
  onCtaClick: (event: React.MouseEvent) => void;
}

export const DashboardTileStateView = (props: IProps) => {
  return (
    <div
      className="flex flex-col items-center justify-center text-center w-full h-full px-4"
      onClick={(event) => event.stopPropagation()}
    >
      <h3 className="font-bold text-lg sm:text-xl text-zeos-black leading-snug">
        {props.heading}
      </h3>
      <p className="text-sm text-black mt-2 max-w-sm">{props.body}</p>
      {props.ctaLabel ? (
        <button
          type="button"
          className="mt-4 cursor-pointer rounded px-3 py-1.5 text-sm text-white bg-zeos-orange-dk"
          onClick={props.onCtaClick}
        >
          {props.ctaLabel}
        </button>
      ) : null}
    </div>
  );
};
